import { FulfilmentCentre } from '../../redux-toolkits/fulfilment-centres/fulfilmentCentres.type'

import { useModalControl } from '../../hooks/useModalControl'
import { ActionChip } from '../cards/actionChip'
import { EditInput } from '../inputs/editInput'
import { SelectFulfilmentCenterModal } from '../modal/app_modals/selectFulfilmentCenter'

export const VendorFulfilmentCenter = ({
  fulfilmentCenters,
  className,
  loading = false,
  onModify = () => {},
  error,
}: {
  fulfilmentCenters?: FulfilmentCentre[]
  className?: string
  loading?: boolean
  onModify?: (
    data: { fulfilmentCenters: FulfilmentCentre[] },
    handleClose: () => void,
  ) => void
  error?: string
}) => {
  const { setModalOpen, handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl()

  return (
    <>
      <EditInput
        title="Fulfilment Centers"
        value={undefined}
        onEditClick={() => {
          handleModalOpen('selectCenterModal')
        }}
        errors={error}
        onCancel={() => {}}
        onEditSave={() => {}}
        editing={false}
        className={className}
      >
        {() => {
          return (
            <div className="flex items-center gap-2 flex-wrap">
              {fulfilmentCenters?.map((fulfilmentCenter) => (
                <ActionChip
                  key={`fulfilment-center-${fulfilmentCenter._id}`}
                  name={`${fulfilmentCenter.name} • ${fulfilmentCenter.address}`}
                />
              ))}
            </div>
          )
        }}
      </EditInput>

      <SelectFulfilmentCenterModal
        open={modalOpen && modal === 'selectCenterModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={(val, resetForm) => {
          if (val) {
            onModify({ fulfilmentCenters: val }, () => {
              handleModalClose()
              resetForm()
            })
          }
        }}
        maxSelection={undefined}
        selectedCenters={fulfilmentCenters}
        loading={loading}
      />
    </>
  )
}
